import { components } from '@/utils'

import svgIcon from '@/components/icon/svg'

function renderIcon(h) {
  if (this.hasIcon) {
    let iconComponent = components.icon
    let value = this.icon
    if (this.iconSVG) {
      iconComponent = svgIcon
      value = this.iconSVG
    }

    return h(
      iconComponent,
      {
        props: {
          value,
          color: this.color,
          size: this.$iconSize
        }
      }
    )
  }

  return this.$slots.default || this.$slots.icon
}

function renderPreLoader(h) {
  return h(
    components.progress,
    {
      props: {
        indeterminate: true,
        color: this.color,
        size: this.$iconSize
      }
    }
  )
}

function renderContent(h) {
  if (this.loading) {
    return renderPreLoader.call(this, h)
  }

  return renderIcon.call(this, h)
}

export default function(h) {
  return h(
    'div',
    {
      class: this.$class,
      directives: this.$directives
    },
    [ renderContent.call(this, h) ]
  )
}
